"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestType = exports.PaymentProcessingStrategies = exports.AccelerateVehicleCondition = exports.SponsorValue = void 0;
var SponsorValue;
(function (SponsorValue) {
    SponsorValue["DDC"] = "DDC";
    SponsorValue["ATC"] = "ATC";
    SponsorValue["KBB"] = "KBB";
})(SponsorValue = exports.SponsorValue || (exports.SponsorValue = {}));
var AccelerateVehicleCondition;
(function (AccelerateVehicleCondition) {
    AccelerateVehicleCondition["NEW"] = "new";
    AccelerateVehicleCondition["USED"] = "used";
    AccelerateVehicleCondition["CERTIFIED"] = "certified";
})(AccelerateVehicleCondition = exports.AccelerateVehicleCondition || (exports.AccelerateVehicleCondition = {}));
/**
 * Possible payment response processing strategies.
 *
 * Some strategies could be applied to questions response,
 * other to actual payment response.
 */
var PaymentProcessingStrategies;
(function (PaymentProcessingStrategies) {
    PaymentProcessingStrategies["default"] = "default";
    PaymentProcessingStrategies["lowestMonthlyPayment"] = "lowestMonthlyPayment";
    PaymentProcessingStrategies["maxCashBack"] = "maxCashBack";
    PaymentProcessingStrategies["lowestAPR"] = "lowestAPR";
    PaymentProcessingStrategies["generic"] = "generic";
    PaymentProcessingStrategies["allQuotes"] = "allQuotes";
})(PaymentProcessingStrategies = exports.PaymentProcessingStrategies || (exports.PaymentProcessingStrategies = {}));
/**
 * Possible requested payment type
 * IDealerPaymentData.payment.requestTypes is an array of requested types
 */
var RequestType;
(function (RequestType) {
    RequestType["CASH"] = "Cash";
    RequestType["FINANCE"] = "Finance";
    RequestType["LEASE"] = "Lease";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
